import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { ReceiptItemUpdateDto } from '../types';

export const useUpdateReceiptItem = (receiptItemId: string) => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<void, Error, ReceiptItemUpdateDto>({
    mutationFn: (data) =>
      apiClient.patch(`/v1/projects/${projectId}/receipt-items/${receiptItemId}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['receipts', projectId] });
      queryClient.invalidateQueries({ queryKey: ['receipt'] });
    },
  });
};
